import { RADIUS, RENDER_ORDER } from "@graphic/constants";
import { RSOTypeValue, SubTypeValue } from "@graphic/types";
import { getColorByType, setSizeByDistance } from "@graphic/utils";
import { useFrame } from "@react-three/fiber";
import { startTransition, useState } from "react";

import * as THREE from "three";

type GeometryProps = {
  type: RSOTypeValue;
  subtype: SubTypeValue;
  transparent?: boolean;
  opacity?: number;
  size?: number;
  rgb?: number;
};

function Geometry({ type, subtype, rgb, transparent, opacity }: GeometryProps) {
  let color;
  if (rgb) {
    color = new THREE.Color(rgb);
  } else {
    color = getColorByType(subtype);
  }

  const [size, setSize] = useState(1);

  const center = new THREE.Vector3(0, 0, 0);

  useFrame(({ camera }) => {
    const distance = center.distanceTo(camera.position) - RADIUS;
    const size = setSizeByDistance(distance);
    startTransition(() => {
      setSize(size);
    });
  }, RENDER_ORDER.OBJECT);

  switch (type) {
    case "PAYLOAD":
      return (
        <>
          <sphereGeometry attach="geometry" args={[size, 32, 32]} />
          <meshPhongMaterial
            attach="material"
            color={color}
            transparent={transparent}
            opacity={opacity}
          />
        </>
      );
    case "ROCKET BODY":
      return (
        <>
          <cylinderGeometry attach="geometry" args={[size, size, size * 2]} />

          <meshPhongMaterial
            attach="material"
            color={color}
            transparent={transparent}
            opacity={opacity}
          />
        </>
      );
    case "DEBRIS":
      return (
        <>
          <tetrahedronGeometry attach="geometry" args={[size, undefined]} />
          <meshPhongMaterial
            attach="material"
            color={color}
            transparent={transparent}
            opacity={opacity}
          />
        </>
      );

    default:
      return (
        <>
          <boxGeometry attach="geometry" args={[size, size, size]} />
          <meshPhongMaterial
            attach="material"
            color={color}
            transparent={transparent}
            opacity={opacity}
          />
        </>
      );
  }
}

export default Geometry;
